import React from "react";
import ReactDOM from "react-dom"
import { ImageGalleryElement } from "@quintype/components";
import canUseDom from "../../../../utils/can-use-dom";

import './image-gallery-lightbox.module.css';

class ImageGalleryLightbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      photoIndex: 0
    };
    this.Lightbox = null;
    this.imageUrlList = props.element['story-elements'].map(image => {
      return `//${props.cdn}/${image['image-s3-key']}`;
    });
  }

  componentDidMount() {
    this.dynamicImport();
  }

  dynamicImport() {
    import(/* webpackChunkName: "Lightbox" */ 'react-image-lightbox').then(Lightbox => {
      this.Lightbox = Lightbox;
    });
  }

  onClickHandler = index => {
    this.setState({
      isOpen: true,
      photoIndex: index
    })
  }

  onMoveNext = () => {
    this.setState({
      photoIndex: (this.state.photoIndex + 1) % this.imageUrlList.length,
    })
  }

  onMovePrev = () => {
    this.setState({
      photoIndex: (this.state.photoIndex + this.imageUrlList.length - 1) % this.imageUrlList.length,
    })
  }

  onClose = () => {
    this.setState({
      isOpen: false,
      photoIndex: 0
    })
  }

  render() {
    return <React.Fragment>
      <ImageGalleryElement onClickHandler={this.onClickHandler} {...this.props} />
      {
        this.state.isOpen && canUseDom && this.Lightbox ?
        <this.Lightbox.default
          wrapperClassName="lightbox-custom-styles"
          mainSrc={this.imageUrlList[this.state.photoIndex]}
          nextSrc={this.imageUrlList[(this.state.photoIndex + 1) % this.imageUrlList.length]}
          prevSrc={this.imageUrlList[(this.state.photoIndex + this.imageUrlList.length - 1) % this.imageUrlList.length]}
          onMoveNextRequest={this.onMoveNext}
          onMovePrevRequest={this.onMovePrev}
          onCloseRequest={this.onClose} /> : null
      }
    </React.Fragment>
  }
}

export { ImageGalleryLightbox };